(function () {
  var fillings = [
    'Krokan',
    'Sütlü Çikolata',
    'Bitter Çikolata',
    'Beyaz Çikolata',
    'Draje Fıstık',
    'Frambuaz',
    'Yaban Mersini',
    'Çilek',
    'Muz',
    'Karışık Orman Meyvesi'
  ];

  function escapeHtml(value) {
    return value.replace(/[&<>\"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[character];
    });
  }

  function findAddToCartForm() {
    var forms = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
    return forms.find(function (form) {
      return form.querySelector('button[name="add"],button[type="submit"],input[type="submit"]');
    }) || forms[0];
  }

  function bindProperties(root) {
    var form = findAddToCartForm();
    if (!form) return false;
    form.setAttribute('id', 'bb-main-product-form');
    form.setAttribute('enctype', 'multipart/form-data');
    root.querySelectorAll('[data-bb-property]').forEach(function (input) {
      input.setAttribute('form', 'bb-main-product-form');
    });
    if (!form.dataset.bbCakePropertiesBound) {
      form.dataset.bbCakePropertiesBound = 'true';
      form.addEventListener('formdata', function (event) {
        root.querySelectorAll('[data-bb-property]').forEach(function (input) {
          if (!input.disabled && input.name && input.value) {
            event.formData.set(input.name, input.value);
          }
        });
      });
    }
    return true;
  }

  function hideLegacyFlavor(root) {
    var picker = root.querySelector('.bb-variant-picker--inside');
    if (!picker) return false;
    if (!picker.dataset.bbRecipeObserved) {
      picker.dataset.bbRecipeObserved = 'true';
      new MutationObserver(function () {
        hideLegacyFlavor(root);
        updateSummary(root);
      }).observe(picker, { childList: true, subtree: true });
    }
    picker.querySelectorAll('.product-form__input,fieldset').forEach(function (group) {
      var heading = group.querySelector('legend,.form__label,label');
      var text = (heading ? heading.textContent : '').replace(/\s+/g, ' ').trim().toLocaleLowerCase('tr-TR');
      var isLegacyFlavor = text.indexOf('lezzet') === 0 || text.indexOf('pasta i\u00e7eri\u011fi') === 0;
      group.classList.toggle('bb-native-flavor-hidden', isLegacyFlavor);
    });
    var oldFlavor = root.querySelector('[data-bb-summary-flavor]');
    if (oldFlavor && oldFlavor.parentElement) oldFlavor.parentElement.hidden = true;
    return true;
  }

  function selectedNativeOption(root, labelText) {
    var picker = root.querySelector('.bb-variant-picker--inside');
    if (!picker) return '';
    var wanted = labelText.toLocaleLowerCase('tr-TR');
    var selected = '';
    picker.querySelectorAll('.product-form__input,fieldset').forEach(function (group) {
      if (selected) return;
      var heading = group.querySelector('legend,.form__label,label');
      var headingText = (heading ? heading.textContent : '').replace(/\s+/g, ' ').trim().toLocaleLowerCase('tr-TR');
      if (headingText.indexOf(wanted) !== 0) return;
      var select = group.querySelector('select');
      var checked = group.querySelector('input[type="radio"]:checked');
      if (select && select.options[select.selectedIndex]) selected = select.options[select.selectedIndex].text.trim();
      else if (checked) selected = String(checked.value || '').trim();
    });
    return selected;
  }

  function hasExternalMessageField() {
    return Boolean(document.querySelector(
      '.pplr-wrapper input[type="text"][name^="properties["],.pplr-wrapper textarea[name^="properties["],[data-bb-print-product-fields] input[name^="properties["],[data-bb-print-product-fields] textarea[name^="properties["]'
    ));
  }

  function syncGenericMessageField(root) {
    var message = root.querySelector('#bb-message');
    if (!message) return false;
    var field = message.closest('.bb-field');
    var summaryMessage = root.querySelector('[data-bb-summary-message]');
    var hideGeneric = root.hasAttribute('data-bb-fixed-design') || hasExternalMessageField();
    message.disabled = hideGeneric;
    if (field) {
      field.hidden = hideGeneric;
      field.style.setProperty('display', hideGeneric ? 'none' : '', hideGeneric ? 'important' : '');
    }
    if (summaryMessage && summaryMessage.parentElement) {
      summaryMessage.parentElement.hidden = hideGeneric;
      summaryMessage.parentElement.style.setProperty('display', hideGeneric ? 'none' : '', hideGeneric ? 'important' : '');
    }
    root.classList.toggle('bb-product-helper--external-message', hideGeneric);
    return hideGeneric;
  }

  function selectedFillings(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-bb-filling]:checked')).map(function (input) {
      return input.value;
    });
  }

  function updateFillings(root) {
    var selected = selectedFillings(root);
    root.querySelectorAll('[data-bb-filling]').forEach(function (input) {
      input.disabled = selected.length >= 2 && !input.checked;
    });

    var first = root.querySelector('[data-bb-filling-one]');
    var second = root.querySelector('[data-bb-filling-two]');
    if (first) {
      first.value = selected[0] || '';
      first.disabled = !selected[0];
    }
    if (second) {
      second.value = selected[1] || '';
      second.disabled = !selected[1];
    }

    var count = root.querySelector('[data-bb-filling-count]');
    if (count) count.textContent = selected.length + '/2 seçildi';
    return selected;
  }

  function addSummaryRows(root) {
    var summary = root.querySelector('[data-bb-order-summary]');
    if (!summary || summary.querySelector('[data-bb-summary-cake]')) return;
    var messageRow = summary.querySelector('[data-bb-summary-message]');
    messageRow = messageRow && messageRow.parentElement;
    var rows = document.createElement('div');
    rows.innerHTML =
      '<div><span>Kek</span><strong data-bb-summary-cake>Seçilmedi</strong></div>' +
      '<div><span>Krema</span><strong data-bb-summary-cream>Seçilmedi</strong></div>' +
      '<div><span>İç malzemeler</span><strong data-bb-summary-fillings>Seçilmedi</strong></div>';
    Array.prototype.slice.call(rows.children).forEach(function (row) {
      summary.insertBefore(row, messageRow || null);
    });
  }

  function updateSummary(root) {
    var cake = root.querySelector('#bb-cake');
    var cream = root.querySelector('#bb-cream');
    var cakeSummary = root.querySelector('[data-bb-summary-cake]');
    var creamSummary = root.querySelector('[data-bb-summary-cream]');
    var fillingsSummary = root.querySelector('[data-bb-summary-fillings]');
    var servingsSummary = root.querySelector('[data-bb-summary-servings]');
    if (cakeSummary) cakeSummary.textContent = cake && cake.value ? cake.value : 'Seçilmedi';
    if (creamSummary) creamSummary.textContent = cream && cream.value ? cream.value : 'Seçilmedi';
    if (fillingsSummary) {
      var values = selectedFillings(root);
      fillingsSummary.textContent = values.length ? values.join(', ') : 'Seçilmedi';
    }
    if (servingsSummary) servingsSummary.textContent = selectedNativeOption(root, 'ki\u015fi say\u0131s\u0131') || '\u2014';
    syncGenericMessageField(root);
  }

  function injectFields(root) {
    var fields = root.querySelector('.bb-fields');
    if (!fields || fields.querySelector('#bb-cake')) return false;
    var fillingMarkup = fillings.map(function (filling) {
      return '<label class="bb-filling-option"><input type="checkbox" value="' + escapeHtml(filling) + '" data-bb-filling><span>' + escapeHtml(filling) + '</span></label>';
    }).join('');

    fields.insertAdjacentHTML('afterbegin',
      '<div class="bb-field">' +
        '<label for="bb-cake">Kek çeşidi</label>' +
        '<select id="bb-cake" class="bb-cake-select" data-bb-property name="properties[Kek çeşidi]" required>' +
          '<option value="">Seçiniz</option><option>Vanilyalı Kek</option><option>Kakaolu Kek</option>' +
        '</select>' +
      '</div>' +
      '<div class="bb-field">' +
        '<label for="bb-cream">Krema</label>' +
        '<select id="bb-cream" class="bb-cake-select" data-bb-property name="properties[Krema]" required>' +
          '<option value="">Seçiniz</option><option>Vanilyalı Krema</option><option>Çikolatalı Krema</option>' +
        '</select>' +
      '</div>' +
      '<fieldset class="bb-field bb-field--wide bb-fillings">' +
        '<legend>İç malzeme <small>En fazla 2 seçim</small></legend>' +
        '<div class="bb-filling-options">' + fillingMarkup + '</div>' +
        '<input type="hidden" data-bb-property data-bb-filling-one name="properties[İç Malzeme 1]" disabled>' +
        '<input type="hidden" data-bb-property data-bb-filling-two name="properties[İç Malzeme 2]" disabled>' +
        '<div class="bb-filling-count" data-bb-filling-count aria-live="polite">0/2 seçildi</div>' +
      '</fieldset>'
    );
    return true;
  }

  function enhanceDesignerMenu() {
    document.querySelectorAll('a[href*="/pages/kendi-pastani-tasarla"]').forEach(function (link) {
      if (!link.closest('header, .header, .shopify-section-group-header-group, #shopify-section-header')) return;
      link.classList.remove('bb-designer-nav-link');
      try {
        var url = new URL(link.href, window.location.origin);
        url.searchParams.set('bb_guide', '1');
        link.href = url.pathname + url.search + url.hash;
      } catch (error) { /* Leave the original theme link untouched when URL parsing is unavailable. */ }
    });
  }

  function initialize() {
    enhanceDesignerMenu();
    var root = document.querySelector('[data-bb-product-helper]');
    if (!root) return;
    injectFields(root);
    addSummaryRows(root);
    hideLegacyFlavor(root);
    bindProperties(root);
    updateFillings(root);
    updateSummary(root);
    syncGenericMessageField(root);

    if (!root.dataset.bbCakeOptionsBound) {
      root.dataset.bbCakeOptionsBound = 'true';
      root.addEventListener('change', function (event) {
        if (event.target.matches('[data-bb-filling]')) updateFillings(root);
        updateSummary(root);
      });
      root.addEventListener('input', function () { updateSummary(root); });
    }

    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      bindProperties(root);
      hideLegacyFlavor(root);
      syncGenericMessageField(root);
      updateSummary(root);
      if (attempts >= 40) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

// Keep Zepto's 3D and production views on the same customer values.
(function () {
  if (location.pathname !== '/products/iron-man-kisisellestirilebilir-baskili-pasta') return;
  var latest = new Map();
  var syncing = false;
  var timer;
  function fields() {
    return Array.from(document.querySelectorAll('input.pplr_text[name^="properties["]'));
  }
  function mirror() {
    if (syncing) return;
    syncing = true;
    try {
      fields().forEach(function (field) {
        if (!latest.has(field.name) || field.value === latest.get(field.name)) return;
        field.value = latest.get(field.name);
        field.dispatchEvent(new Event('input', { bubbles: true }));
        field.dispatchEvent(new Event('change', { bubbles: true }));
      });
    } finally { syncing = false; }
  }
  function remember(event) {
    var field = event.target;
    if (syncing || !field.matches('input.pplr_text[name^="properties["]')) return;
    latest.set(field.name, field.value);
    mirror();
    clearTimeout(timer);
    timer = setTimeout(mirror, 150);
  }
  document.addEventListener('input', remember);
  document.addEventListener('change', remember);
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.pplr_tab_index')) return;
    setTimeout(mirror, 0);
    setTimeout(mirror, 150);
  });
  document.addEventListener('submit', mirror, true);
})();

// Keep Iron Man's Zepto image navigation separate from the theme image lightbox.
(function () {
  if (location.pathname !== '/products/iron-man-kisisellestirilebilir-baskili-pasta') return;
  var style = document.createElement('style');
  style.textContent = '.product__media-zoom{display:none!important}.pplr_preview_wrapper{touch-action:pan-y;cursor:grab}.pplr_preview_wrapper .pplr_ov_layer{pointer-events:none!important}.pplr_preview_wrapper .pplr_arrows,.pplr_preview_wrapper .pplr_prev_type_wrapper{z-index:20!important}.pplr_preview_wrapper .pplr_arrow{pointer-events:auto!important;cursor:pointer;opacity:1!important;background:#fff!important;color:#783c52!important;border:1px solid #eadfe3;border-radius:50%;box-shadow:0 2px 8px #0002;font:700 28px/1 Arial,sans-serif!important}.pplr_preview_wrapper .pplr_arrow i{display:none!important}.pplr_preview_wrapper .pplr_arrow_left:before{content:"‹"}.pplr_preview_wrapper .pplr_arrow_right:before{content:"›"}.pplr_preview_wrapper .pplr-dot{opacity:1!important;background:#bcb4b8!important}.pplr_preview_wrapper .pplr-dot.active{background:#783c52!important}';
  document.head.appendChild(style);
  var bound = new WeakSet(), controlsBound = new WeakSet();
  function bind() {
    document.querySelectorAll('.pplr_preview_wrapper').forEach(function (wrapper) {
      wrapper.querySelectorAll('.pplr_arrow,.pplr-preview-item').forEach(function (control, index) {
        if (controlsBound.has(control)) return;
        controlsBound.add(control);
        control.setAttribute('role','button');
        control.setAttribute('tabindex','0');
        control.setAttribute('aria-label', control.classList.contains('pplr_arrow_right') ? 'Sonraki görsel' : control.classList.contains('pplr_arrow_left') ? 'Önceki görsel' : 'Pasta görseli ' + (index + 1));
        control.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); control.click(); }
        });
      });
      if (bound.has(wrapper)) return;
      bound.add(wrapper);
      var start = null, suppressUntil = 0;
      wrapper.addEventListener('click', function (event) {
        if (event.target.closest('.pplr_arrow,.pplr-preview-item') || Date.now() < suppressUntil) {
          event.stopPropagation();
          event.preventDefault();
        }
      });
      wrapper.addEventListener('pointerdown', function (event) {
        if (event.target.closest('.pplr_arrow,.pplr-preview-item')) return;
        start = {x:event.clientX,y:event.clientY};
      });
      wrapper.addEventListener('pointercancel', function () { start = null; });
      wrapper.addEventListener('pointerup', function (event) {
        if (!start) return;
        var dx = event.clientX - start.x, dy = event.clientY - start.y;
        start = null;
        if (Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy) * 1.25) return;
        suppressUntil = Date.now() + 350;
        var arrow = wrapper.querySelector(dx < 0 ? '.pplr_arrow_right' : '.pplr_arrow_left');
        if (arrow) arrow.click();
      });
      wrapper.querySelectorAll('.pplr_arrow,.pplr-preview-item').forEach(function (control, index) {
        control.setAttribute('role','button');
        control.setAttribute('tabindex','0');
        control.setAttribute('aria-label', control.classList.contains('pplr_arrow_right') ? 'Sonraki görsel' : control.classList.contains('pplr_arrow_left') ? 'Önceki görsel' : 'Pasta görseli ' + (index + 1));
        control.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); control.click(); }
        });
      });
    });
  }
  bind();
  new MutationObserver(bind).observe(document.body,{childList:true,subtree:true});
})();

// Keep each V4 cake's customer text identical in its cake and production views.
(function () {
  var handles = ["avengers-birlikte-guclu-kisisellestirilebilir-baskili-pasta","spider-man-ag-atisi-kisisellestirilebilir-baskili-pasta","batman-comic-patlama-kisisellestirilebilir-baskili-pasta","spider-man-kirmizi-ag-kisisellestirilebilir-baskili-pasta","batman-gotham-ucusu-kisisellestirilebilir-baskili-pasta","spider-man-beyaz-amblem-kisisellestirilebilir-baskili-pasta","spider-man-maske-kisisellestirilebilir-baskili-pasta","minik-spider-sehir-kisisellestirilebilir-baskili-pasta","batman-zirh-kisisellestirilebilir-baskili-pasta","spider-man-iki-dunya-kisisellestirilebilir-baskili-pasta","iron-man-enerji-kisisellestirilebilir-baskili-pasta","iron-man-sehir-ucusu-kisisellestirilebilir-baskili-pasta","batman-sari-sinyal-kisisellestirilebilir-baskili-pasta","deadpool-wolverine-kisisellestirilebilir-baskili-pasta","spider-man-gece-kisisellestirilebilir-baskili-pasta","minik-batman-gotham-kisisellestirilebilir-baskili-pasta","spider-man-logo-kisisellestirilebilir-baskili-pasta","iron-man-repulsor-kisisellestirilebilir-baskili-pasta"];
  handles = handles.concat(["frozen-fotografli-kar-cercevesi-kisisellestirilebilir-baskili-pasta","frozen-elsa-buz-sarayi-kisisellestirilebilir-baskili-pasta","frozen-elsa-olaf-kar-vadisi-kisisellestirilebilir-baskili-pasta","frozen-elsa-anna-kardeslik-kisisellestirilebilir-baskili-pasta","frozen-kis-macerasi-kisisellestirilebilir-baskili-pasta"]);
  handles = handles.concat(["paw-01-fotografli-pati-kisisellestirilebilir-baskili-pasta","paw-02-chase-gorevde-kisisellestirilebilir-baskili-pasta","paw-03-renkli-ekip-kisisellestirilebilir-baskili-pasta","paw-04-macera-korfezi-kisisellestirilebilir-baskili-pasta","paw-05-skye-pembe-ekip-kisisellestirilebilir-baskili-pasta"]);
  handles = handles.concat(["stitch-01-tropik-dans-baskili-pasta","stitch-02-kagit-surprizi-baskili-pasta","stitch-03-sahil-baskili-pasta","stitch-04-sorf-baskili-pasta","stitch-05-fotografli-baskili-pasta"]);
  var babyHandles = ["ayin-uykucu-baykusu-baby-shower-baskili-pasta","ayicigin-sicak-yuvasi-baby-shower-baskili-pasta","kedicik-ve-minik-patikler-baby-shower-baskili-pasta"];
  handles = handles.concat(babyHandles);
  handles = handles.concat(["sonic-01-neon-baskili-pasta","sonic-02-hiz-baskili-pasta","sonic-03-dogum-gunu-baskili-pasta","sonic-04-ekip-baskili-pasta","sonic-05-fotografli-baskili-pasta"]);
  handles = handles.concat(["minecraft-01-steve-alex-baskili-pasta","minecraft-02-creeper-baskili-pasta","minecraft-03-tavuk-suvarisi-baskili-pasta","minecraft-04-dunya-baskili-pasta","minecraft-05-fotografli-baskili-pasta"]);
  var canonical = document.querySelector('link[rel="canonical"]');
  var productPath = location.pathname;
  if (canonical) {
    try { productPath = new URL(canonical.href).pathname; } catch (error) { /* Use the current product path. */ }
  }
  if (handles.indexOf(productPath.split('/').filter(Boolean).pop()) < 0) return;
  // Zepto exports its 300-DPI canvas using 96-DPI inch units. Keep the
  // original artwork coordinates, but declare the production diameter in mm.
  var NativePrintBlob = window.Blob;
  function normalizePrintSvg(source, fonts) {
    var root = source.match(/<svg\b[^>]*>/i);
    if (!root) return source;
    function canvasSize(attribute) {
      var match = root[0].match(new RegExp('\\b' + attribute + '="([0-9.]+)(in|px)?"', 'i'));
      return match ? Number(match[1]) * (match[2] === 'in' ? 96 : 1) : 0;
    }
    if (Math.abs(canvasSize('width') - 4252) > 0.01 || Math.abs(canvasSize('height') - 4252) > 0.01) return source;
    var sizedRoot = root[0].replace(/\s(?:width|height|viewBox)="[^"]*"/gi, '');
    sizedRoot = sizedRoot.slice(0, -1) + ' width="360mm" height="360mm" viewBox="0 0 4252 4252">';
    source = source.replace(root[0], sizedRoot);
    // Use Zepto's already-loaded font bytes so the SVG keeps its typography
    // when opened away from the storefront.
    return source.replace(/@font-face\s*\{[^}]*\}/g, function (rule) {
      var family = rule.match(/font-family:\s*['"]([^'"]+)['"]/);
      var entry = family && fonts && fonts[family[1]];
      if (!entry || !/^[A-Za-z0-9+/]+=*$/.test(entry[1] || '')) return rule;
      return rule.replace(/src:\s*url\([^)]*\)/, 'src: url(data:font/ttf;base64,' + entry[1] + ')');
    });
  }
  if (NativePrintBlob && !NativePrintBlob.bbHero36cm) {
    class HeroPrintBlob extends NativePrintBlob {
      constructor(parts, options) {
        if (options && options.type === 'image/svg+xml' && parts && parts.length === 1 && typeof parts[0] === 'string') {
          parts = [normalizePrintSvg(parts[0], window.font_face_array)];
        }
        super(parts, options);
      }
    }
    HeroPrintBlob.bbHero36cm = true;
    window.Blob = HeroPrintBlob;
  }

  var selector = 'input.pplr_text[name^="properties["],textarea[name^="properties["]';
  var latest = new Map(), textLayouts = new WeakMap(), syncing = false, timer;
  function splitMessage(value) {
    var text = Array.from(value.replace(/\s+/g, ' ').replace(/^\s+/, '')).slice(0, 22).join('');
    if (text.length <= 12) return { value: text, joiner: ' ' };
    var candidates = [];
    for (var i = 1; i < text.length; i++) {
      var a = text.slice(0, i).trim(), b = text.slice(i).replace(/^\s+/, '');
      if (!b.trim() || a.length > 12 || b.length > 12) continue;
      var wordBreak = text[i] === ' ' || text[i - 1] === ' ';
      candidates.push({ a: a, b: b, joiner: wordBreak ? ' ' : '', score: Math.abs(a.length - b.length) + (wordBreak ? 0 : 30) });
    }
    candidates.sort(function (a, b) { return a.score - b.score; });
    return candidates.length ? { value: candidates[0].a + '\n' + candidates[0].b, joiner: candidates[0].joiner } : { value: text.slice(0, 11) + '\n' + text.slice(11), joiner: '' };
  }
  function normalize(field, event) {
    if (productPath.indexOf('/products/minecraft-') >= 0) {
      if (field.name === 'properties[İsim]') return Array.from(field.value.replace(/\s+/g, ' ')).slice(0, 12).join('');
      if (field.name === 'properties[Pasta mesajınız]' || field.name === 'properties[Mesajınız]') {
        if (/minecraft-0[34]-/.test(productPath)) return Array.from(field.value.replace(/\s+/g, ' ')).slice(0, 22).join('');
        return splitMessage(field.value).value;
      }
    }
    if (babyHandles.indexOf(productPath.split('/').filter(Boolean).pop()) >= 0 || productPath.indexOf('/products/stitch-02-kagit-surprizi-') >= 0) {
      if (field.name === 'properties[İsim]') return Array.from(field.value.replace(/\s+/g, ' ')).slice(0, 12).join('');
      if (field.name === 'properties[Pasta mesajınız]') return splitMessage(field.value).value;
    }
    if ((productPath.indexOf('/products/frozen-') >= 0 || productPath.indexOf('/products/paw-') >= 0 || productPath.indexOf('/products/stitch-') >= 0 || productPath.indexOf('/products/sonic-') >= 0) && (field.name === 'properties[Pasta mesajınız]' || field.name === 'properties[Mesajınız]' || field.name === 'properties[İsim]')) return Array.from(field.value.replace(/\s+/g, ' ')).slice(0, field.name === 'properties[İsim]' ? 12 : 22).join('');
    if (field.name === 'properties[Mesajınız]' && field.tagName === 'TEXTAREA') {
      var prior = textLayouts.get(field);
      if (event.inputType === 'insertFromPaste' || event.inputType === 'insertFromDrop') prior = null;
      var layout = splitMessage(field.value.replace(/\r?\n/g, prior ? prior.joiner : ' '));
      textLayouts.set(field, layout);
      return layout.value;
    }
    if (field.name === 'properties[Yaş]') return field.value.replace(/\D/g, '').slice(0, 2);
    return field.value;
  }
  function mirror() {
    if (syncing) return;
    syncing = true;
    try {
      document.querySelectorAll(selector).forEach(function (field) {
        if (!latest.has(field.name)) return;
        var value = latest.get(field.name);
        if (field.tagName === 'INPUT') value = value.replace(/\n/g, ' ');
        if (field.value === value) return;
        field.value = value;
        field.dispatchEvent(new Event('input', { bubbles: true }));
        field.dispatchEvent(new Event('change', { bubbles: true }));
      });
    } finally { syncing = false; }
  }
  function remember(event) {
    var field = event.target;
    if (syncing || field.disabled || !field.matches(selector)) return;
    var value = normalize(field, event), oldLength = field.value.length, cursor = field.selectionStart;
    if (field.value !== value) {
      field.value = value;
      if (cursor !== null) {
        var next = Math.max(0, Math.min(value.length, cursor + value.length - oldLength));
        try { field.setSelectionRange(next, next); } catch (error) { /* Number inputs do not expose a caret. */ }
      }
    }
    latest.set(field.name, value);
    mirror();
    clearTimeout(timer);
    timer = setTimeout(mirror, 150);
  }
  document.addEventListener('input', remember, true);
  document.addEventListener('change', remember, true);
  document.addEventListener('submit', mirror, true);
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.pplr_tab_index,.pplr_arrow,.pplr-preview-item')) return;
    setTimeout(mirror, 0);
    setTimeout(mirror, 150);
  });

  var style = document.createElement('style');
  style.textContent = '.product__media-zoom,.product__media-icon{display:none!important}.pplr_preview_wrapper{touch-action:pan-y;cursor:grab}.pplr_preview_wrapper .pplr_ov_layer{pointer-events:none!important}.pplr_preview_wrapper .pplr_arrows,.pplr_preview_wrapper .pplr_prev_type_wrapper{z-index:20!important}.pplr_preview_wrapper .pplr_arrow{pointer-events:auto!important;cursor:pointer;opacity:1!important;background:#fff!important;color:#783c52!important;border:1px solid #eadfe3;border-radius:50%;box-shadow:0 2px 8px #0002;font:700 28px/1 Arial,sans-serif!important}.pplr_preview_wrapper .pplr_arrow i{display:none!important}.pplr_preview_wrapper .pplr_arrow_left:before{content:"‹"}.pplr_preview_wrapper .pplr_arrow_right:before{content:"›"}.pplr_preview_wrapper .pplr-dot{opacity:1!important;background:#bcb4b8!important}.pplr_preview_wrapper .pplr-dot.active{background:#783c52!important}.bb-hero-gallery .product__media-gallery-thumbails,.bb-hero-gallery .slider-controls--group{display:none!important}.bb-hero-gallery{display:block!important}.bb-hero-gallery .product__media-gallery-viewer-wrap{width:100%!important;margin:0!important}.bb-hero-gallery .product__media-list{transform:none!important;display:block!important;height:auto!important}.bb-hero-gallery .product__media-item{display:none!important}.bb-hero-gallery .product__media-item:has(.pplr_preview_wrapper){display:block!important;width:100%!important;margin:0!important}';
  document.head.appendChild(style);
  var bound = new WeakSet(), controlsBound = new WeakSet();
  function bind() {
    document.querySelectorAll('.pplr_preview_wrapper').forEach(function (wrapper) {
      var gallery = wrapper.closest('media-gallery');
      if (gallery && !gallery.classList.contains('bb-hero-gallery')) gallery.classList.add('bb-hero-gallery');
      wrapper.querySelectorAll('.pplr_arrow,.pplr-preview-item').forEach(function (control, index) {
        if (controlsBound.has(control)) return;
        controlsBound.add(control);
        control.setAttribute('role', 'button');
        control.setAttribute('tabindex', '0');
        control.setAttribute('aria-label', control.classList.contains('pplr_arrow_right') ? 'Sonraki görsel' : control.classList.contains('pplr_arrow_left') ? 'Önceki görsel' : 'Pasta görseli ' + (index + 1));
        control.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); control.click(); }
        });
      });
      if (bound.has(wrapper)) return;
      bound.add(wrapper);
      var start = null, suppressUntil = 0;
      wrapper.addEventListener('click', function (event) {
        if (event.target.closest('.pplr_arrow,.pplr-preview-item') || Date.now() < suppressUntil) {
          event.stopPropagation();
          event.preventDefault();
        }
      });
      wrapper.addEventListener('pointerdown', function (event) {
        event.stopPropagation();
        if (!event.target.closest('.pplr_arrow,.pplr-preview-item')) start = { x: event.clientX, y: event.clientY };
      });
      wrapper.addEventListener('pointercancel', function () { start = null; });
      wrapper.addEventListener('pointerup', function (event) {
        event.stopPropagation();
        if (!start) return;
        var dx = event.clientX - start.x, dy = event.clientY - start.y;
        start = null;
        if (Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy) * 1.25) return;
        suppressUntil = Date.now() + 350;
        var arrow = wrapper.querySelector(dx < 0 ? '.pplr_arrow_right' : '.pplr_arrow_left');
        if (arrow) arrow.click();
      });
    });
  }
  bind();
  new MutationObserver(bind).observe(document.body, { childList: true, subtree: true });
})();



// Keep storefront gallery sizing separate from Zepto's photo crop preview.
(function(){
 var protectPath=location.pathname, canonical=document.querySelector('link[rel="canonical"]');
 if(canonical){try{protectPath=new URL(canonical.href).pathname;}catch(error){}}
 if (protectPath.indexOf('/products/frozen-')!==0 && protectPath.indexOf('/products/paw-')!==0 && protectPath.indexOf('/products/stitch-')!==0 && protectPath.indexOf('/products/sonic-')!==0 && protectPath.indexOf('/products/minecraft-')!==0) return;
 var style=document.createElement('style');
 style.textContent='.pplr-wrapper[data-id="lQpPrc7tWI"],.pplr-wrapper[data-id="bDL3msHEuS"]{display:none!important}.pplr-wrapper textarea{resize:none!important}.bb-hero-gallery .product__media-item{display:block!important}main media-gallery .product__media>.pplr_preview_wrapper{width:100%!important;height:100%!important;left:0!important;top:0!important;margin:0!important}main media-gallery .pplr_preview_wrapper canvas{width:100%!important;height:100%!important}';
 document.head.appendChild(style);
 function protect(){
  document.querySelectorAll('.pplr-wrapper input.pplr_text,.pplr-wrapper textarea.pplr_text').forEach(function(field){
   if(field.name==='properties[Yaş]'){field.inputMode='numeric';field.pattern='[0-9]{1,2}';}
   if(field.tagName==='TEXTAREA'){var lines=((protectPath.indexOf('/products/stitch-02-kagit-surprizi-')===0 || /\/products\/minecraft-0[125]-/.test(protectPath)) && (field.name==='properties[Pasta mesajınız]' || field.name==='properties[Mesajınız]'))?2:1;field.setAttribute('maxline',String(lines));field.rows=lines;}
  });
  var cropOpen=Array.from(document.querySelectorAll('.pplr_crop-modal')).some(function(modal){return getComputedStyle(modal).display!=='none';});
  if(cropOpen)return;
  var host=document.querySelector('main media-gallery .product__media');
  var preview=document.querySelector('main .pplr_preview_wrapper');
  if(host&&preview&&!preview.closest('.pplr_crop-modal')&&preview.parentElement!==host){
   preview.parentElement.classList.remove('pplr');host.classList.add('pplr');host.appendChild(preview);
  }
 }
 protect();new MutationObserver(protect).observe(document.body,{childList:true,subtree:true});
})();
